import * as R from 'ramda';

import {
    NOTIFICATIONS_OPEN_SYSTEM,
    NOTIFICATIONS_CLOSE_SYSTEM,
    NOTIFICATIONS_OPEN_VALIDATION,
    NOTIFICATIONS_CLOSE_VALIDATION
} from './constants';

const defaultState = {
    system: {
        open: false,
        message: ""
    },
    validation: {
        open: false,
        messages: []
    }
};

const notifications = (state = defaultState, { type, payload }) => {
    switch (type) {
        case NOTIFICATIONS_OPEN_SYSTEM: {
            const system = {
                open: true,
                message: payload
            };
            return R.merge(state, { system });
        }
        case NOTIFICATIONS_CLOSE_SYSTEM: {
            const system = defaultState.system;
            return R.merge(state, { system });
        }
        case NOTIFICATIONS_OPEN_VALIDATION: {
            const validation = {
                open: true,
                messages: payload
            };
            return R.merge(state, { validation });
        }
        case NOTIFICATIONS_CLOSE_VALIDATION: {
            const validation = defaultState.validation;
            return R.merge(state, { validation });
        }
        default:
            return state;
    }
};

export default notifications;
